var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useLanguage } from '@base/LanguageProvider';
import { TagType, } from '@common/api';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { useTableTagRelationsActions } from '@data/tag/tagRelationActions';
import { isTableTagJsonData } from '@data/tag/types';
import { useOutsideClick } from '@hooks/useOutsideClick';
import useTableCells, { DEFAULT_CELL_HEIGHT } from '@hooks/useTableCells';
import ContextMenu from '@shared/contextmenu/ContextMenu';
import * as FarseerIcons from '@shared/icons/icons';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import Tags from '@shared/tags/Tags';
import { ContextMenuBoxItem, ContextMenuLabel, ContextMenuVerticalHr } from '@styled/ContextMenu';
import { TEConnectionPickerWrapper, TECustomInputBox, TEHeaderMenuWrapper, TEHeaderRenameInput, } from '@styled/TagEditor';
import useTheme, { appColors } from '@styled/useTheme';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Sheet from 'sheet-happens';
import 'sheet-happens/dist/index.css';
import { useExpSearchables } from '../../../data/hooks/expSearchables';
import { useAuth } from '../../../providers/AuthProvider';
import ExpEditor from '../../../shared/expression/ExpEditor';
import { handleApiErrorMessage, warning } from '../../../util/message';
import { createContextMenuItems, createHeaderMenuItems, customColumnIconMap } from './menuItems';
import { calculateTagPerms } from './permissions';
import { TagGroup } from './TagGroup';
import { mapTagRepresentationToEditTagData, TagEditorColumnType, } from './useTagTable';
var NO_CHANGE_PLACEHOLDER = ':no_change:';
var FROZEN_COLUMNS = 1;
var DEFAULT_COLUMN_WIDTH = 250;
var DEFAULT_LAST_COLUMN_WIDTH = 32;
export function TagEditorTable(_a) {
    var _this = this;
    var tagTable = _a.tagTable, batchDeleteTagsHandler = _a.batchDeleteTagsHandler, removeCustomColumn = _a.removeCustomColumn, renameCustomColumn = _a.renameCustomColumn, selectedTagId = _a.selectedTagId, selectedGroupId = _a.selectedGroupId, selectTableHandler = _a.selectTableHandler, tagType = _a.tagType, tagSearchFilter = _a.tagSearchFilter, tableActions = _a.tableActions, tagActionsMap = _a.tagActionsMap;
    var L = useLanguage().L;
    var theme = useTheme();
    var user = useAuth().user;
    var searchables = useExpSearchables();
    var tagClassActions = user === null || user === void 0 ? void 0 : user.classActions.tagClassActions;
    var tagData = useTagContext().tagData;
    var _b = useTagActions(), batchCreateTags = _b.batchCreateTags, batchEditTags = _b.batchEditTags, editTagJsonData = _b.editTagJsonData, editTag = _b.editTag;
    var _c = useTableTagRelationsActions(), addTableTagRelation = _c.addTableTagRelation, removeTableTagRelation = _c.removeTableTagRelation, addTableRelationConnectedTag = _c.addTableRelationConnectedTag, removeTableRelationConnectedTag = _c.removeTableRelationConnectedTag, addAndRemoveTableRelationConnectedTags = _c.addAndRemoveTableRelationConnectedTags;
    // state of cell widths and heights
    var _d = useTableCells(tagTable.columns.map(function (c) {
        return c !== undefined && c.type === TagEditorColumnType.AddNewButton
            ? DEFAULT_LAST_COLUMN_WIDTH
            : DEFAULT_COLUMN_WIDTH;
    })), onCellWidthChange = _d.onCellWidthChange, onCellHeightChange = _d.onCellHeightChange, setCellWidth = _d.setCellWidth, cellWidth = _d.cellWidth, cellHeight = _d.cellHeight;
    // update table column widths when number of columns changes
    useEffect(function () {
        var _a;
        var newWidths = [];
        for (var i = 0; i < tagTable.columns.length - 1; i++) {
            if (cellWidth[i] !== undefined && i < cellWidth.length - 1) {
                // keep old widths (except for last which is add new column button)
                newWidths[i] = cellWidth[i];
            }
            else {
                newWidths[i] = DEFAULT_COLUMN_WIDTH;
            }
        }
        if (((_a = tagTable.columns[tagTable.columns.length - 1]) === null || _a === void 0 ? void 0 : _a.type) === TagEditorColumnType.AddNewButton) {
            newWidths[tagTable.columns.length - 1] = DEFAULT_LAST_COLUMN_WIDTH;
        }
        else {
            newWidths[tagTable.columns.length - 1] = DEFAULT_COLUMN_WIDTH;
        }
        setCellWidth(newWidths);
    }, [tagTable.columns.length]);
    var _e = __read(useState({ x1: -1, y1: -1, x2: -1, y2: -1 }), 2), selection = _e[0], setSelection = _e[1];
    var _f = __read(useState(0), 2), columnOffset = _f[0], setColumnOffset = _f[1];
    // state of header menu
    var closedHeaderMenuProps = {
        columnIndex: -1,
        visible: false,
        left: 0,
        top: 0,
        items: [],
    };
    var _g = __read(useState(closedHeaderMenuProps), 2), headerMenuProps = _g[0], setHeaderMenuProps = _g[1];
    // state of connection picker
    var _h = __read(useState({ visible: false, top: 0, left: 0 }), 2), connectionPickerPosition = _h[0], setConnectionPickerPosition = _h[1];
    var closeConnectionPicker = function () {
        setConnectionPickerPosition(function (currentState) {
            return currentState.visible ? { visible: false, top: 0, left: 0 } : currentState;
        });
    };
    // state of header name input
    var _j = __read(useState({
        visible: false,
        left: 0,
        top: 0,
        width: 0,
        initialValue: '',
        uniqueId: '',
    }), 2), editedHeader = _j[0], setEditedHeader = _j[1];
    // refs
    var sheetWrapperRef = useRef(null);
    var fileInputRef = useRef(null);
    var getSheetColumnOffset = function (columnIndex) {
        var _a, _b, _c;
        var _d = (_b = (_a = sheetWrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : {
            left: 0,
            top: 0,
        }, sheetLeft = _d.left, sheetTop = _d.top;
        var columnsBeforeWidth = cellWidth
            .filter(function (w, idx) { return idx < FROZEN_COLUMNS || (idx >= columnOffset && idx < columnIndex); })
            .reduce(function (sum, width) { return sum + (width !== null && width !== void 0 ? width : 0); }, 0);
        var columnWidth = (_c = cellWidth[columnIndex]) !== null && _c !== void 0 ? _c : 0;
        return {
            top: sheetTop,
            left: sheetLeft + columnsBeforeWidth + 50,
            columnWidth: columnWidth,
        };
    };
    var filteredTagRows = useMemo(function () {
        if (tagSearchFilter === undefined || tagSearchFilter.data === '') {
            return tagTable.rows;
        }
        var filteredRows = tagTable.rows.filter(function (r) {
            return tagSearchFilter.fields.some(function (field) {
                if (field === 'connections') {
                    return tagTable.columns.some(function (col) {
                        return col !== undefined &&
                            col.type === TagEditorColumnType.Connection &&
                            (tagSearchFilter.matchCase ? col.getValue(r) : col.getValue(r).toLowerCase()).includes(tagSearchFilter.matchCase ? tagSearchFilter.data : tagSearchFilter.data.toLowerCase());
                    });
                }
                else {
                    var tagFieldString = String(r.tag[field]);
                    return (tagSearchFilter.matchCase ? tagFieldString : tagFieldString.toLowerCase()).includes(tagSearchFilter.matchCase ? tagSearchFilter.data : tagSearchFilter.data.toLowerCase());
                }
            });
        });
        return filteredRows;
    }, [tagSearchFilter, tagTable]);
    var onSelectionChanged = function (x1, y1, x2, y2) {
        setSelection({ x1: x1, y1: y1, x2: x2, y2: y2 });
    };
    var onScrollChange = function (x, y) {
        if (x !== columnOffset) {
            setColumnOffset(x);
        }
    };
    var addColumn = function (columnType, customColumnInfo) { return __awaiter(_this, void 0, void 0, function () {
        var selectedTag, sheetOffset, jsonData, existingUniqueIds, newUniqueId;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectedTag = tagData.tagById[selectedTagId !== null && selectedTagId !== void 0 ? selectedTagId : -1];
                    if (selectedTag === undefined || selectedTag.type !== TagType.Table) {
                        return [2 /*return*/];
                    }
                    if (columnType === TagEditorColumnType.Connection) {
                        sheetOffset = getSheetColumnOffset(tagTable.columns.length - 1);
                        setConnectionPickerPosition({
                            visible: true,
                            top: sheetOffset.top + DEFAULT_CELL_HEIGHT,
                            left: sheetOffset.left,
                        });
                    }
                    if (!(columnType === TagEditorColumnType.Custom && customColumnInfo !== undefined)) return [3 /*break*/, 2];
                    jsonData = (_a = selectedTag.jsonData) !== null && _a !== void 0 ? _a : { headers: [] };
                    if (!isTableTagJsonData(jsonData)) {
                        return [2 /*return*/];
                    }
                    existingUniqueIds = new Set(jsonData.headers.map(function (h) { return h.uniqueId; }));
                    newUniqueId = '';
                    do {
                        newUniqueId =
                            Math.random().toPrecision(18).substring(2, 10) + Math.random().toPrecision(18).substring(2, 10);
                    } while (existingUniqueIds.has(newUniqueId));
                    return [4 /*yield*/, editTagJsonData(selectedTag.id, {
                            headers: __spreadArray(__spreadArray([], __read(jsonData.headers), false), [
                                { name: customColumnInfo.name, type: customColumnInfo.type, uniqueId: newUniqueId },
                            ], false),
                        })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var columnHeaders = function (index) {
        var _a, _b;
        var column = tagTable.columns[index];
        if (column === undefined) {
            return '';
        }
        var cellObj = {
            items: [],
        };
        var columnRenameHandler = function () {
            if (column.type !== TagEditorColumnType.Custom) {
                return;
            }
            var sheetOffset = getSheetColumnOffset(index);
            setEditedHeader({
                visible: true,
                left: sheetOffset.left,
                top: sheetOffset.top,
                width: sheetOffset.columnWidth,
                initialValue: column.name,
                uniqueId: column.uniqueId,
            });
        };
        var columnHeaderMenuHandler = function () {
            if (headerMenuProps.columnIndex === index) {
                setHeaderMenuProps(closedHeaderMenuProps);
            }
            else {
                var sheetOffset = getSheetColumnOffset(index);
                setHeaderMenuProps({
                    columnIndex: index,
                    visible: true,
                    left: sheetOffset.left + sheetOffset.columnWidth - 32,
                    top: sheetOffset.top + DEFAULT_CELL_HEIGHT,
                    items: createHeaderMenuItems(column, L, columnRenameHandler, addColumn, removeCustomColumn, removeTableTagRelation),
                });
            }
        };
        switch (column.type) {
            case TagEditorColumnType.Default:
            case TagEditorColumnType.Formula:
            case TagEditorColumnType.Dimensions: {
                cellObj.items.push({
                    x: 0,
                    y: 0,
                    content: column.name,
                    horiozntalAlign: 'left',
                });
                break;
            }
            case TagEditorColumnType.Custom: {
                var ColumnIcon = customColumnIconMap[column.customColumnType];
                cellObj.items.push({
                    x: 0,
                    y: -12,
                    content: FarseerIcons.getIconAsHTMLImageElement(React.createElement(ColumnIcon, null)),
                    width: 24,
                    height: 24,
                    horiozntalAlign: 'left',
                });
                cellObj.items.push({
                    x: 24,
                    y: 0,
                    content: column.name,
                    horiozntalAlign: 'left',
                });
                if (tableActions.canEdit) {
                    cellObj.items.push({
                        x: 0,
                        y: -12,
                        content: FarseerIcons.getIconAsHTMLImageElement(React.createElement(FarseerIcons.ChevronDown, null)),
                        width: 24,
                        height: 24,
                        horiozntalAlign: 'right',
                        onClick: columnHeaderMenuHandler,
                    });
                }
                break;
            }
            case TagEditorColumnType.Connection: {
                cellObj.items.push({
                    x: 0,
                    y: -12,
                    content: FarseerIcons.getIconAsHTMLImageElement(React.createElement(FarseerIcons.Connection, { creative: true })),
                    width: 24,
                    height: 24,
                    horiozntalAlign: 'left',
                });
                cellObj.items.push({
                    x: 24,
                    y: 0,
                    content: (_b = (_a = tagData.tagById[column.relation.connectedTableTagId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
                    horiozntalAlign: 'left',
                });
                if (tableActions.canEdit) {
                    cellObj.items.push({
                        x: 0,
                        y: -12,
                        content: FarseerIcons.getIconAsHTMLImageElement(React.createElement(FarseerIcons.ChevronDown, { creative: true })),
                        width: 24,
                        height: 24,
                        horiozntalAlign: 'right',
                        onClick: columnHeaderMenuHandler,
                    });
                }
                break;
            }
            case TagEditorColumnType.AddNewButton: {
                if (tableActions.canEdit) {
                    cellObj.items.push({
                        x: 0,
                        y: -12,
                        content: FarseerIcons.getIconAsHTMLImageElement(React.createElement(FarseerIcons.Plus, null)),
                        width: 24,
                        height: 24,
                        horiozntalAlign: 'center',
                        onClick: columnHeaderMenuHandler,
                    });
                }
                break;
            }
        }
        return cellObj;
    };
    var cellStyle = function (fontWeight) {
        return function (x) {
            var column = tagTable.columns[x];
            return {
                fontFamily: 'Inter',
                fontSize: 12,
                weight: fontWeight,
                color: (column === null || column === void 0 ? void 0 : column.type) === TagEditorColumnType.Connection || (column === null || column === void 0 ? void 0 : column.type) === TagEditorColumnType.Dimensions
                    ? theme.colors.primary.w500
                    : theme.colors.ui.dark,
            };
        };
    };
    var editData = function (x, y) {
        var tagRow = filteredTagRows[y];
        if (!tagRow) {
            return '';
        }
        var column = tagTable.columns[x];
        if (!column) {
            return '';
        }
        return column.getValue(tagRow);
    };
    var editKeys = function (x, y) {
        var tagRow = filteredTagRows[y];
        if (!tagRow) {
            return '';
        }
        var column = tagTable.columns[x];
        if (!column) {
            return '';
        }
        var key = "".concat(tagRow.id, "-").concat(column.key);
        return key;
    };
    var displayData = function (x, y) {
        var tagRow = filteredTagRows[y];
        if (!tagRow) {
            return '';
        }
        var column = tagTable.columns[x];
        if (!column) {
            return '';
        }
        return column.getValue(tagRow);
    };
    var sourceData = function (x, y) {
        var tagRow = filteredTagRows[y];
        if (!tagRow) {
            return null;
        }
        var column = tagTable.columns[x];
        if (column === undefined) {
            return null;
        }
        return column.type === TagEditorColumnType.Connection
            ? column.getConnectedTagsIdsString(tagRow)
            : column.getValue(tagRow);
    };
    var onChange = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var changesFiltered, tagIdsToDelete, tagsToUpdate, tagsToCreate, connectionsByRelationId, changesFiltered_1, changesFiltered_1_1, change, newValStr, column, tagRow, tagData_1, newTagData, tagRowActions, tagData_2, newTagData, relationConnections, updates, _a, _b, _c, relationId, relationConnections, e_1_1, tagCreateInfos, uniqueNames, monthsId_1, yearsId_1, versionsId_1, error_1;
        var e_2, _d, _e, _f, e_1, _g;
        var _h, _j, _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    changesFiltered = changes.filter(function (c) { return c.value !== NO_CHANGE_PLACEHOLDER; });
                    if (changesFiltered.length === 0) {
                        // no changes
                        return [2 /*return*/];
                    }
                    if (changesFiltered.length > 1) {
                        // show loading if working on more than 1 tag
                        startGlobalLoading();
                    }
                    tagIdsToDelete = new Set();
                    tagsToUpdate = new Map();
                    tagsToCreate = new Map();
                    connectionsByRelationId = new Map();
                    try {
                        for (changesFiltered_1 = __values(changesFiltered), changesFiltered_1_1 = changesFiltered_1.next(); !changesFiltered_1_1.done; changesFiltered_1_1 = changesFiltered_1.next()) {
                            change = changesFiltered_1_1.value;
                            newValStr = String((_h = change.value) !== null && _h !== void 0 ? _h : '');
                            column = tagTable.columns[change.x];
                            if (column === undefined) {
                                continue;
                            }
                            tagRow = filteredTagRows[change.y];
                            if (tagRow === undefined) {
                                // create new tag
                                if (!tableActions.canCreate) {
                                    // skip creating if user has no create permission
                                    continue;
                                }
                                if (newValStr === '') {
                                    continue;
                                }
                                tagData_1 = (_j = tagsToCreate.get(change.y)) !== null && _j !== void 0 ? _j : {
                                    name: '',
                                    description: null,
                                    jsonData: null,
                                };
                                newTagData = column.applyChange(tagData_1, newValStr);
                                if (newTagData !== undefined) {
                                    if ('name' in newTagData) {
                                        // update tag properties
                                        tagsToCreate.set(change.y, newTagData);
                                    }
                                    // no handling for connections right now
                                }
                            }
                            else {
                                tagRowActions = calculateTagPerms(tagClassActions, tagActionsMap, tagRow.tag);
                                if (change.x === 0 && newValStr === '') {
                                    // if name (first column) was deleted, delete tag
                                    if (tagRowActions.canDelete) {
                                        tagIdsToDelete.add(tagRow.tag.id);
                                    }
                                }
                                else {
                                    if (!tagRowActions.canDelete &&
                                        column.type === TagEditorColumnType.Connection &&
                                        newValStr === '') {
                                        // don't allow delete connections if user has no delete permission
                                        continue;
                                    }
                                    if (!tagRowActions.canEdit) {
                                        // don't edit tag if user has no edit permission
                                        continue;
                                    }
                                    tagData_2 = (_k = tagsToUpdate.get(tagRow.tag.id)) !== null && _k !== void 0 ? _k : mapTagRepresentationToEditTagData(tagRow.tag);
                                    newTagData = column.applyChange(tagData_2, newValStr);
                                    if (newTagData !== undefined) {
                                        if ('name' in newTagData) {
                                            // update tag properties
                                            tagsToUpdate.set(tagRow.tag.id, newTagData);
                                        }
                                        else {
                                            // update tag connections
                                            if (column.type === TagEditorColumnType.Connection) {
                                                relationConnections = connectionsByRelationId.get(column.relation.id);
                                                if (relationConnections === undefined) {
                                                    relationConnections = { tagConnectionsToAdd: [], tagConnectionsToRemove: [] };
                                                    connectionsByRelationId.set(column.relation.id, relationConnections);
                                                }
                                                (_e = relationConnections.tagConnectionsToAdd).push.apply(_e, __spreadArray([], __read(newTagData.tagConnectionsToAdd), false));
                                                (_f = relationConnections.tagConnectionsToRemove).push.apply(_f, __spreadArray([], __read(newTagData.tagConnectionsToRemove), false));
                                            }
                                            else {
                                                warning("".concat(L('Got wrong result type for column'), " ").concat(column.key));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (changesFiltered_1_1 && !changesFiltered_1_1.done && (_d = changesFiltered_1.return)) _d.call(changesFiltered_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    _p.label = 1;
                case 1:
                    _p.trys.push([1, 18, 19, 20]);
                    if (!(tagsToUpdate.size > 0)) return [3 /*break*/, 3];
                    updates = Array.from(tagsToUpdate.values())
                        .map(function (editTagData) {
                        if (editTagData.id === undefined) {
                            // can't edit tag if no id is present
                            return undefined;
                        }
                        if (tagIdsToDelete.has(editTagData.id)) {
                            // don't edit tags that may be deleted
                            return undefined;
                        }
                        var tag = tagData.tagById[editTagData.id];
                        if (tag === undefined) {
                            // skip tags that are not found in tagData
                            return undefined;
                        }
                        // apply changes to full tag object
                        var editedTag = __assign(__assign({}, tag), editTagData);
                        return editedTag;
                    })
                        .filter(function (t) { return t !== undefined; });
                    return [4 /*yield*/, batchEditTags(updates)];
                case 2:
                    _p.sent();
                    _p.label = 3;
                case 3:
                    if (!(connectionsByRelationId.size > 0)) return [3 /*break*/, 11];
                    _p.label = 4;
                case 4:
                    _p.trys.push([4, 9, 10, 11]);
                    _a = __values(connectionsByRelationId.entries()), _b = _a.next();
                    _p.label = 5;
                case 5:
                    if (!!_b.done) return [3 /*break*/, 8];
                    _c = __read(_b.value, 2), relationId = _c[0], relationConnections = _c[1];
                    return [4 /*yield*/, addAndRemoveTableRelationConnectedTags(relationId, relationConnections.tagConnectionsToAdd, relationConnections.tagConnectionsToRemove)];
                case 6:
                    _p.sent();
                    _p.label = 7;
                case 7:
                    _b = _a.next();
                    return [3 /*break*/, 5];
                case 8: return [3 /*break*/, 11];
                case 9:
                    e_1_1 = _p.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 11];
                case 10:
                    try {
                        if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 11:
                    if (!(tagIdsToDelete.size > 0)) return [3 /*break*/, 13];
                    // delete tags (batch)
                    return [4 /*yield*/, batchDeleteTagsHandler(Array.from(tagIdsToDelete))];
                case 12:
                    // delete tags (batch)
                    _p.sent();
                    _p.label = 13;
                case 13:
                    if (!(tagsToCreate.size > 0)) return [3 /*break*/, 17];
                    tagCreateInfos = Array.from(tagsToCreate.values());
                    uniqueNames = new Set(tagCreateInfos.map(function (t) { return t.name; }));
                    if (tagCreateInfos.length !== uniqueNames.size) {
                        throw new Error(L('Tried to add non unique tags'));
                    }
                    if (uniqueNames.has('')) {
                        throw new Error(L('Tried to create tag with empty name'));
                    }
                    if (!(tagType === TagType.Dimension)) return [3 /*break*/, 15];
                    if (selectedTagId == null || selectedTagId === 0) {
                        throw new Error(L('No table selected'));
                    }
                    return [4 /*yield*/, batchCreateTags(tagCreateInfos.map(function (tagInfo) {
                            var _a;
                            return {
                                name: tagInfo.name,
                                type: TagType.Dimension,
                                ParentId: selectedTagId,
                                description: (_a = tagInfo.description) !== null && _a !== void 0 ? _a : undefined,
                                jsonData: tagInfo.jsonData,
                            };
                        }))];
                case 14:
                    _p.sent();
                    return [3 /*break*/, 17];
                case 15:
                    if (!(tagType === TagType.Account)) return [3 /*break*/, 17];
                    if (selectedGroupId == null || selectedGroupId === 0) {
                        throw new Error(L('No group selected'));
                    }
                    monthsId_1 = (_l = tagData.internalTagsMap.months) === null || _l === void 0 ? void 0 : _l[0].ParentId;
                    yearsId_1 = (_m = tagData.internalTagsMap.years) === null || _m === void 0 ? void 0 : _m[0].ParentId;
                    versionsId_1 = (_o = tagData.internalTagsMap.versions) === null || _o === void 0 ? void 0 : _o[0].ParentId;
                    if (monthsId_1 === null || yearsId_1 === null || versionsId_1 === null) {
                        throw new Error('Unable to find internal tags');
                    }
                    return [4 /*yield*/, batchCreateTags(tagCreateInfos.map(function (tagInfo) {
                            var _a, _b;
                            return {
                                name: tagInfo.name,
                                type: TagType.Account,
                                ParentId: selectedGroupId,
                                description: (_a = tagInfo.description) !== null && _a !== void 0 ? _a : undefined,
                                jsonData: null,
                                dimensionTagIds: (_b = tagInfo.dimensionTagIds) !== null && _b !== void 0 ? _b : [monthsId_1, yearsId_1, versionsId_1],
                                topDownEnabled: false,
                            };
                        }))];
                case 16:
                    _p.sent();
                    selectTableHandler(0, selectedGroupId);
                    _p.label = 17;
                case 17: return [3 /*break*/, 20];
                case 18:
                    error_1 = _p.sent();
                    handleApiErrorMessage(error_1);
                    return [3 /*break*/, 20];
                case 19:
                    if (changesFiltered.length > 1) {
                        stopGlobalLoading();
                    }
                    return [7 /*endfinally*/];
                case 20: return [2 /*return*/];
            }
        });
    }); };
    var isReadOnly = function (x, y) {
        var _a;
        var column = tagTable.columns[x];
        if (column === undefined || column.readonly) {
            return true;
        }
        if (x >= 0 && y < filteredTagRows.length) {
            var tagRowTag = (_a = filteredTagRows[y]) === null || _a === void 0 ? void 0 : _a.tag;
            var tagRowActions = calculateTagPerms(tagClassActions, tagActionsMap, tagRowTag);
            return !tagRowActions.canEdit;
        }
        else if (x >= 0 && y >= filteredTagRows.length) {
            return !tableActions.canCreate;
        }
        return false;
    };
    var handleCellWidthChange = function (indices, newWidth) {
        var e_3, _a;
        var indicesToChange = [];
        try {
            for (var indices_1 = __values(indices), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
                var columnIndex = indices_1_1.value;
                var column = tagTable.columns[columnIndex];
                if (column !== undefined && column.type !== TagEditorColumnType.AddNewButton) {
                    indicesToChange.push(columnIndex);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (indices_1_1 && !indices_1_1.done && (_a = indices_1.return)) _a.call(indices_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        onCellWidthChange(indicesToChange, newWidth);
    };
    var sheetCustomInput = function (x, y, inputProps, commit) {
        var _a, _b, _c, _d;
        var tagRow = filteredTagRows[y];
        if (!tagRow) {
            return;
        }
        var column = tagTable.columns[x];
        if (column === undefined) {
            return;
        }
        if (column.type === TagEditorColumnType.Connection) {
            var connectedTags_1 = tagRow && tagRow.tag && column ? column.getConnectedTags(tagRow) : [];
            var updateConnectedTags = function (tagId) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(column.relation.id && tagRow.tag && tagRow.tag.id)) return [3 /*break*/, 5];
                            if (!connectedTags_1.find(function (t) { return t.id === tagId; })) return [3 /*break*/, 2];
                            return [4 /*yield*/, removeTableRelationConnectedTag(column.relation.id, tagRow.tag.id, tagId)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, addTableRelationConnectedTag(column.relation.id, tagRow.tag.id, tagId)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            inputProps.onChange(NO_CHANGE_PLACEHOLDER);
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); };
            return (React.createElement(CustomTagInput, { tags: connectedTags_1, inputProps: inputProps, onChange: updateConnectedTags, filterByParentIds: [column.relation.connectedTableTagId] }));
        }
        if (column.type === TagEditorColumnType.Dimensions) {
            return (React.createElement(CustomTagInput, { tags: (_b = (_a = tagRow.tag.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.map(function (t) { return tagData.tagById[t]; })) !== null && _b !== void 0 ? _b : [], inputProps: inputProps, onChange: function (tagId) { return __awaiter(_this, void 0, void 0, function () {
                    var tagIds;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                tagIds = tagRow.tag.dimensionTagIds.filter(function (t) { return t !== tagId; });
                                if (!(tagIds.length === ((_a = tagRow.tag.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.length))) return [3 /*break*/, 2];
                                return [4 /*yield*/, editTag(__assign(__assign({}, tagRow.tag), { dimensionTagIds: ((_b = tagRow.tag) === null || _b === void 0 ? void 0 : _b.dimensionTagIds)
                                            ? __spreadArray(__spreadArray([], __read(tagRow.tag.dimensionTagIds), false), [tagId], false) : [tagId] }))];
                            case 1:
                                _c.sent();
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, editTag(__assign(__assign({}, tagRow.tag), { dimensionTagIds: tagIds }))];
                            case 3:
                                _c.sent();
                                _c.label = 4;
                            case 4:
                                inputProps.onChange(NO_CHANGE_PLACEHOLDER);
                                return [2 /*return*/];
                        }
                    });
                }); }, filterByType: [TagType.Table, TagType.Dimension] }));
        }
        if (column.type === TagEditorColumnType.Formula) {
            var top = inputProps.style.top;
            var height = inputProps.style.height;
            var ciTop = top && typeof top === 'number' && height && typeof height === 'number' ? top : 0;
            return (React.createElement("div", { style: __assign(__assign({}, inputProps.style), { overflow: 'hidden', backgroundColor: appColors.ui.white, top: ciTop }) },
                React.createElement(ExpEditor, { style: { height: inputProps.style.height }, done: function (exp) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, editTag(__assign(__assign({}, tagRow.tag), { expression: exp }))];
                                case 1:
                                    _a.sent();
                                    inputProps.onChange(NO_CHANGE_PLACEHOLDER);
                                    commit === null || commit === void 0 ? void 0 : commit();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, accTagId: tagRow.tag.id, expression: (_d = (_c = tagRow.tag) === null || _c === void 0 ? void 0 : _c.expression) !== null && _d !== void 0 ? _d : '', searchables: searchables })));
        }
        return;
    };
    var contextMenuItems = createContextMenuItems(selection, filteredTagRows, tagTable.columns, fileInputRef, editTagJsonData, tagActionsMap, tagClassActions, L);
    return (React.createElement("div", { style: { position: 'relative', width: '100%', height: '100%' }, ref: sheetWrapperRef },
        React.createElement(Sheet, { key: "".concat(selectedTagId, "/").concat(selectedGroupId), onSelectionChanged: onSelectionChanged, onScrollChange: onScrollChange, columnHeaders: columnHeaders, columnHeaderStyle: cellStyle('bold'), cellStyle: cellStyle('normal'), editData: editData, displayData: displayData, sourceData: sourceData, cellWidth: cellWidth, cellHeight: cellHeight, onChange: onChange, readOnly: isReadOnly, onCellWidthChange: handleCellWidthChange, onCellHeightChange: onCellHeightChange, sheetStyle: { freezeColumns: FROZEN_COLUMNS }, editKeys: editKeys, inputComponent: sheetCustomInput }),
        React.createElement("input", { ref: fileInputRef, type: "file", style: { display: 'none' } }),
        React.createElement(FloatingTextInput, { visible: editedHeader.visible, top: editedHeader.top, left: editedHeader.left, width: editedHeader.width, initialValue: editedHeader.initialValue, onConfirm: function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(newValue !== null)) return [3 /*break*/, 2];
                            // value can be null if wanting to reset name
                            return [4 /*yield*/, renameCustomColumn(editedHeader.uniqueId, newValue)];
                        case 1:
                            // value can be null if wanting to reset name
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            setEditedHeader({ visible: false, top: 0, left: 0, width: 0, initialValue: '', uniqueId: '' });
                            return [2 /*return*/];
                    }
                });
            }); } }),
        React.createElement(ContextMenu, { items: contextMenuItems, visible: contextMenuItems.length > 0, triggerRefs: [{ ref: sheetWrapperRef }] }),
        React.createElement(TagEditorHeaderMenu, __assign({}, headerMenuProps, { closeMenu: function () { return setHeaderMenuProps(closedHeaderMenuProps); } })),
        React.createElement(TagEditorConnectionPicker, { selectedGroupId: selectedGroupId, tagData: tagData, tagActionsMap: tagActionsMap, currentUser: user, createTableConnection: function (connectedTableTagId) { return __awaiter(_this, void 0, void 0, function () {
                var selectedTag, connectedTableTag;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (selectedTagId === null || selectedTagId === 0) {
                                return [2 /*return*/];
                            }
                            selectedTag = tagData.tagById[selectedTagId];
                            if (selectedTag === undefined || selectedTag.type !== TagType.Table) {
                                return [2 /*return*/];
                            }
                            connectedTableTag = tagData.tagById[connectedTableTagId];
                            if (connectedTableTag === undefined || connectedTableTag.type !== TagType.Table) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, addTableTagRelation({
                                    tableTagId: selectedTagId,
                                    connectedTableTagId: connectedTableTagId,
                                    name: "".concat(selectedTag.name, "-").concat(selectedTagId, "-").concat(connectedTableTag.name, "-").concat(connectedTableTagId),
                                    description: "".concat(selectedTag.name, "-").concat(connectedTableTag.name),
                                })];
                        case 1:
                            _a.sent();
                            closeConnectionPicker();
                            return [2 /*return*/];
                    }
                });
            }); }, close: closeConnectionPicker, position: connectionPickerPosition })));
}
function CustomTagInput(_a) {
    var inputProps = _a.inputProps, tags = _a.tags, onChange = _a.onChange, filterByParentIds = _a.filterByParentIds, filterByType = _a.filterByType;
    var top = inputProps.style.top;
    var height = inputProps.style.height;
    var ciTop = top && typeof top === 'number' && height && typeof height === 'number' ? top : 0;
    return (React.createElement("div", { style: __assign(__assign({}, inputProps.style), { top: ciTop }) },
        React.createElement(TECustomInputBox, null,
            React.createElement(Tags, { canUpdate: true, tiny: true, filterByTypes: filterByType, filterByParentIds: filterByParentIds, tags: tags, remove: onChange, select: onChange, autoEdit: true }))));
}
function TagEditorHeaderMenu(_a) {
    var visible = _a.visible, left = _a.left, top = _a.top, items = _a.items, closeMenu = _a.closeMenu;
    var wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, closeMenu);
    return createPortal(React.createElement(TEHeaderMenuWrapper, { ref: wrapperRef, "$visible": visible, "$left": "".concat(left, "px"), "$top": "".concat(top, "px") }, items.map(function (item, idx) {
        return item.spacer ? (React.createElement(ContextMenuVerticalHr, { key: "item-".concat(idx) })) : (React.createElement(React.Fragment, { key: "item-".concat(idx) },
            React.createElement(ContextMenuBoxItem, { onKeyDown: function (e) {
                    e.key === 'Enter' && item.Component && closeMenu();
                }, onClick: function (e) {
                    var _a;
                    e.stopPropagation();
                    (_a = item.action) === null || _a === void 0 ? void 0 : _a.call(item, e);
                    item.action && closeMenu();
                }, "$isComponent": !!item.Component, "$isDisabled": !!item.isDisabled, "$iconOnly": item.icon !== undefined && item.actionName === undefined },
                item.icon && (React.createElement(item.icon, { destructive: item.destructive, creative: item.creative, disabled: item.isDisabled })),
                item.actionName && (React.createElement(ContextMenuLabel, { "$creative": item.creative, "$destructive": item.destructive, "$disabled": item.isDisabled, "$fillIconSpace": item.icon === undefined }, item.actionName)),
                item.Component && React.createElement(item.Component, { style: { marginLeft: item.icon ? '8px' : '16px' } })),
            item.break && React.createElement(ContextMenuVerticalHr, null)));
    })), document.getElementById('portal'));
}
function TagEditorConnectionPicker(_a) {
    var selectedGroupId = _a.selectedGroupId, tagData = _a.tagData, tagActionsMap = _a.tagActionsMap, currentUser = _a.currentUser, createTableConnection = _a.createTableConnection, close = _a.close, position = _a.position;
    var _b = __read(useState([selectedGroupId !== null && selectedGroupId !== void 0 ? selectedGroupId : 0]), 2), expandedGroups = _b[0], setExpandedGroups = _b[1];
    var wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, close);
    useEffect(function () {
        setExpandedGroups(selectedGroupId !== null ? [selectedGroupId] : []);
    }, [selectedGroupId]);
    var toggleGroupExpanded = function (groupId) {
        var expandedGroupsCopy = [];
        if (expandedGroups.includes(groupId)) {
            expandedGroupsCopy = expandedGroups.filter(function (gId) { return gId !== groupId; });
        }
        else {
            expandedGroupsCopy = __spreadArray(__spreadArray([], __read(expandedGroups), false), [groupId], false);
        }
        setExpandedGroups(expandedGroupsCopy);
    };
    return createPortal(React.createElement(TEConnectionPickerWrapper, { ref: wrapperRef, "$visible": position.visible, "$top": position.top, "$left": position.left },
        React.createElement(TagGroup, { groupId: null, selectedGroupId: selectedGroupId, tagsByParentId: tagData.tagsByParentId, tagByLowercaseName: tagData.tagsByLowercase, selectGroupHandler: toggleGroupExpanded, selectTableHandler: function (tableTagId) { return createTableConnection(tableTagId); }, expandGroupHandler: toggleGroupExpanded, expanded: expandedGroups, filterByType: [TagType.Group, TagType.Table], tagActionsMap: tagActionsMap, user: currentUser, allGroups: tagData.groupTags, changeTagParent: function () { return undefined; }, allowGroupActions: false })), document.getElementById('portal'));
}
function FloatingTextInput(_a) {
    var _this = this;
    var visible = _a.visible, initialValue = _a.initialValue, onConfirm = _a.onConfirm, top = _a.top, left = _a.left, width = _a.width;
    var inputRef = useRef(null);
    var _b = __read(useState(initialValue), 2), textValue = _b[0], setTextValue = _b[1];
    useEffect(function () {
        setTextValue(initialValue);
        if (visible && inputRef.current) {
            inputRef.current.focus();
        }
    }, [visible]);
    return createPortal(React.createElement(TEHeaderRenameInput, { "$visible": visible, "$top": top, "$left": left, "$width": width, "$height": DEFAULT_CELL_HEIGHT, ref: inputRef, type: "text", value: textValue, onChange: function (e) { return setTextValue(e.target.value); }, onKeyUp: function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(e.key === 'Enter')) return [3 /*break*/, 2];
                        return [4 /*yield*/, onConfirm(textValue)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(e.key === 'Escape')) return [3 /*break*/, 4];
                        return [4 /*yield*/, onConfirm(null)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); }, onBlur: function () { return onConfirm(textValue); } }), document.getElementById('portal'));
}
